import { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

export const useOnlineDrivers = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const q = query(collection(db, 'driver_states'), where('online', '==', true));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setCount(snapshot.size);
    });
    return () => unsubscribe();
  }, []);

  return count;
};
